// extracted by mini-css-extract-plugin
export default {"feelingIcon":"FeelingsInput_feelingIcon__9feu6","selectedFeelingIcon":"FeelingsInput_selectedFeelingIcon__c412x"};